import React from 'react'
import RequestForm from './component/RequestForm'


function WalletRequest() {

  return (
    <div>
     <RequestForm/>
    </div>
  )
}


export default WalletRequest;
